import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem, darken } from 'polished';
import carouselTheme from '../styles/carouselTheme'; // Slick carousel has an active class on the parent <li> element
// Pull request: Pass in if current dot is activeDot on customPaging
// https://github.com/akiran/react-slick/pull/1270

var SliderDot = styled.button.withConfig({
  displayName: "SliderDot",
  componentId: "sc-23bujt-0"
})(["background-color:", ";border-radius:50%;border-width:0;border-style:solid;border-color:", ";cursor:pointer;height:", ";margin:0;padding:0;width:", ";transition:all 0.15s ease-in-out;&:hover,&:focus{outline:none;transform:scale(0.95);}", " ", ""], function (props) {
  return props.theme.carousel && props.theme.carousel.dots && props.theme.carousel.dots.background && props.theme.carousel.dots.background[props.dotsType] || carouselTheme.carousel.dots.background[props.dotsType];
}, function (props) {
  return props.theme.carousel && props.theme.carousel.dots && props.theme.carousel.dots.border && props.theme.carousel.dots.border[props.dotsType] || carouselTheme.carousel.dots.border[props.dotsType];
}, function (_ref) {
  var theme = _ref.theme,
      dotsType = _ref.dotsType;
  return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]));
}, function (_ref2) {
  var theme = _ref2.theme,
      dotsType = _ref2.dotsType;
  return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]));
}, function (props) {
  return props.dotsType === 'default' && css([".slick-active &{background-color:", ";}"], darken(0.25, props.theme.carousel && props.theme.carousel.dots && props.theme.carousel.dots.background && props.theme.carousel.dots.background.default || carouselTheme.carousel.dots.background.default));
}, function (props) {
  return props.dotsType === 'primary' && css(["border-width:2px;.slick-active &{background-color:", ";}"], props.theme.carousel && props.theme.carousel.dots && props.theme.carousel.dots.border && props.theme.carousel.dots.border.primary || carouselTheme.carousel.dots.border.primary);
});
export default SliderDot;